import { ISSUE_PRIORITY } from '@/_legacy/constants';
import { v4 as uuidv4 } from 'uuid';

export default {
  issueItem: ({
    node_id = null,
    uuid = null,
    title = '',
    description = '',
    assignees = [],
    associateAssignees = [],
    assignedGroups = [],
    priority = ISSUE_PRIORITY.MEDIUM,
    suggestedCorrectiveAction = '',
    dueIn = null,
    showInspectorIssueIsRaised = false,
    entityItemSpecificAssignments = false,
    approvalsEnabled = false,
    approvalsEntitySpecificAssignments = false,
    approvers = [],
    executedAt = null,
    settings = {
      assignees_enabled: false,
      assignees_required: false,
      description_enabled: false,
      description_required: false,
      due_after_enabled: false,
      due_after_required: false,
      photos_enabled: false,
      photos_required: false,
      priority_enabled: false,
      priority_required: false,
      title_enabled: false,
      title_required: false
    }
  } = {}) => ({
    ...(node_id ? { node_id } : {}),
    uuid: uuid || uuidv4(),
    type: 'action',
    action: 'issue',
    visible_for_conductor: showInspectorIssueIsRaised,
    entity_item_specific_assignments: entityItemSpecificAssignments,
    approvals_enabled: approvalsEnabled,
    approvals_entity_specific_assignments: approvalsEntitySpecificAssignments,
    executed_at: executedAt,
    settings,
    params: {
      title,
      description,
      suggested_corrective_action: suggestedCorrectiveAction,
      due_in: dueIn,
      priority,
      associateAssignees,
      approvers: {
        users: approvers,
      },
      assignees: {
        users: assignees,
        groups: assignedGroups,
        roles: null,
        entity_items: null,
        administrators: false,
      },
    },
  }),
  inspectionActionItem: ({
    uuid = null,
    checklistId = null,
    title = '',
    assignees = [],
    associateAssignees = [],
    assignedGroups = [],
    dueIn = null,
    executedAt = null,
    approvalsEnabled = false,
    approvalsEntitySpecificAssignments = false,
    approvers = [],
  } = {}) => ({
    uuid: uuid || uuidv4(),
    type: 'action',
    action: 'inspection',
    executed_at: executedAt,
    approvals_enabled: approvalsEnabled,
    approvals_entity_specific_assignments: approvalsEntitySpecificAssignments,
    params: {
      checklist_id: checklistId,
      title,
      due_in: dueIn,
      associateAssignees,
      approvers: {
        users: approvers,
      },
      assignees: {
        users: assignees,
        groups: assignedGroups,
        roles: null,
        entity_items: null,
        administrators: false,
      },
    },
  }),
};
